"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactour = _interopRequireDefault(require("reactour"));

var _Step = _interopRequireDefault(require("./Step"));

var _retailAnalytics = require("@jsainsburyplc/retail-analytics");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Tutorial = function Tutorial(_ref) {
  var displayTutorial = _ref.displayTutorial,
      onCloseTutorial = _ref.onCloseTutorial,
      steps = _ref.steps,
      onStepView = _ref.onStepView,
      notSkippable = _ref.notSkippable;
  var lastStepIndex = steps.length - 1;

  var _useState = (0, _react.useState)(0),
      currentStep = _useState[0],
      setCurrentStep = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isDismissed = _useState2[0],
      setIsDismissed = _useState2[1];

  var _useAnalytics = (0, _retailAnalytics.useAnalytics)(),
      sendEvent = _useAnalytics.sendEvent; //set onStepView to 0


  onStepView(0);
  (0, _react.useEffect)(function () {
    if (displayTutorial && !isDismissed) {
      sendEvent(_retailAnalytics.TUTORIAL_BEGIN);
    }
  }, [displayTutorial, isDismissed]);

  var leaveTutorial = function leaveTutorial(fromFinish) {
    if (fromFinish) {
      sendEvent(_retailAnalytics.TUTORIAL_COMPLETE);
    } else if (!fromFinish) {
      sendEvent(_retailAnalytics.TUTORIAL_DISMISSED);
    }

    setIsDismissed(true);
    onCloseTutorial(fromFinish);
  };

  var setStep = function setStep(stepNum) {
    setCurrentStep(stepNum);
    onStepView(stepNum);
  };

  var stepComps = steps.map(function (step, index) {
    return {
      // eslint-disable-next-line react/display-name
      content: function content() {
        return /*#__PURE__*/_react.default.createElement(_Step.default, {
          key: step.title,
          title: step.title,
          description: step.description,
          image: step.image,
          stepIndex: index,
          nextStep: function nextStep() {
            return index < lastStepIndex ? setStep(currentStep + 1) : leaveTutorial(true);
          },
          previousStep: function previousStep() {
            return index > 0 ? setStep(currentStep - 1) : false;
          },
          lastStepIndex: lastStepIndex,
          skipTutorial: function skipTutorial() {
            return leaveTutorial(false);
          },
          notSkippable: notSkippable
        });
      }
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "tourPlaceholder"
  }, /*#__PURE__*/_react.default.createElement(_reactour.default, {
    steps: stepComps,
    getCurrentStep: function getCurrentStep(step) {
      return setCurrentStep(step);
    },
    goToStep: currentStep,
    isOpen: displayTutorial && !isDismissed,
    accentColor: "#f06c00",
    maskClassName: "u-tutorial-mask",
    showNavigation: false,
    showNumber: false,
    showCloseButton: false,
    showButtons: false,
    onRequestClose: function onRequestClose() {
      return leaveTutorial(false);
    },
    onAfterOpen: function onAfterOpen() {
      return setCurrentStep(0);
    }
  }));
};

Tutorial.propTypes = {
  /** Toggles the visibility of the tutorial */
  displayTutorial: _propTypes.default.bool,

  /** The event emitted when the close button has been hit on the tutorial, also emits whether the user has finished the tutorial or not as a boolean */
  onCloseTutorial: _propTypes.default.func,
  onStepView: _propTypes.default.func,

  /** The data passed to the tutorial to render the individual steps */
  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** The title of the tutorial step */
    title: _propTypes.default.string,

    /** The description of the tutorial step */
    description: _propTypes.default.string,

    /** The image to be displayed as part of this step above the content, it can be a url or an image from within your solution */
    image: _propTypes.default.string
  })),

  /** Indicates whether the steps of the tutorial can be skipped or not */
  notSkippable: _propTypes.default.bool
};
Tutorial.defaultProps = {
  displayTutorial: false,
  onCloseTutorial: function onCloseTutorial() {},
  onStepView: function onStepView() {},
  steps: [{
    title: 'hello world',
    description: 'lorem ipsum dolor sit amet',
    image: 'https://via.placeholder.com/150'
  }, {
    title: 'hello world2',
    description: 'lorem ipsum dolor sit amet',
    image: 'https://via.placeholder.com/150'
  }],
  notSkippable: false
};
var _default = Tutorial;
exports.default = _default;